// usePaddle.js
import { useState, useEffect } from 'react';
import { initializePaddle } from '@paddle/paddle-js';
import { PaddleBearer, PaddleToken } from '../assets/constants/PaddleStrings';

export const usePaddle = (
  eventCallbackFunction,
  redirectIfSuccess = false,
  isUpdateSubscription = false
) => {
  const [paddle, setPaddle] = useState(null);

  useEffect(() => {
    initializePaddle({
      environment: 'production',
      token: PaddleToken,
      pwAuth: PaddleBearer,
      eventCallback: eventCallbackFunction,
      // function (data) {
      //   if (data.name === 'checkout.completed') {
      //     eventCallbackFunction(data);
      //     closeCheckout();
      //   }
      // },
    }).then((paddleInstance) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, [eventCallbackFunction]);

  const closeCheckout = () => {
    paddle?.Checkout.close();
  };

  const openCheckout = (itemsList, transactionId) => {
    // console.log(paddle);

    let data = {
      settings: {
        displayMode: 'overlay',
        theme: 'light',
        locale: 'en',
        allowedPaymentMethods: ['card'],
        successUrl: redirectIfSuccess
          ? isUpdateSubscription
            ? 'https://regulationcity.com/app/my-account/membership-info'
            : 'https://regulationcity.com/app/'
          : null,
      },
    };

    if (transactionId) {
      data = {
        ...data,
        transactionId: transactionId,
      };
    } else {
      data = {
        ...data,
        items: itemsList,
      };
    }

    paddle?.Checkout.open(data);
  };

  return { paddle, openCheckout, closeCheckout };
};
